/* istanbul ignore file */
import { useParams } from 'react-router-dom';
import { DeleteButton } from 'framework/ui/ui-builder';
import {
  ASSIGNMENT_DELETE_MESSAGE,
  DELETE_ASSIGNMENT,
  useAssignmentService,
  useAssignmentUrl,
} from 'domain/shared/assignment';

const DeleteAssignmentButton = () => {
  const { id: assignmentId } = useParams<Dictionary<string>>();
  const { deleteById } = useAssignmentService();
  const { getListUrl } = useAssignmentUrl();

  return (
    <DeleteButton
      deleteMethod={() => deleteById(assignmentId!)}
      displayMessage={ASSIGNMENT_DELETE_MESSAGE}
      afterDelete={{
        redirectUrl: getListUrl(),
        successMessage: 'The Assignment has been successfully deleted.',
        errorMessage: `Can't delete assignment`,
      }}
      permissionToCheck={DELETE_ASSIGNMENT}
    />
  );
};

export default DeleteAssignmentButton;
